/* NOBL Creator LP — shared behaviour for all nlp-* sections.
   - Hero color picker publishes the selected variant; every [data-nlp-cta], [data-nlp-sync-*]
     element on the page (in any section) follows it.
   - Countdown timers ([data-nlp-timer])
   - Gallery thumbnails
   Safe to include multiple times (guarded), re-inits on Theme Editor section reloads. */
(function () {
  if (window.NoblLP) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function buildHref(s) {
    if (!s || !s.vid) return null;
    switch (s.mode) {
      case 'checkout': return root + 'cart/' + s.vid + ':1';
      case 'cart': return root + 'cart/add?id=' + s.vid + '&quantity=1';
      case 'custom':
        if (s.custom) return s.custom.replace(/\{vid\}/g, s.vid);
        /* falls through */
      default:
        var base = s.base || '';
        return base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + s.vid;
    }
  }

  function apply(s) {
    if (!s) return;
    var href = buildHref(s);
    document.querySelectorAll('[data-nlp-cta]').forEach(function (a) {
      if (a.dataset.nlpLock === 'true') return;
      if (href) a.setAttribute('href', href);
      var t = a.dataset.labelTemplate;
      if (t) a.textContent = t.replace(/\[price\]/g, s.price || '');
    });
    document.querySelectorAll('[data-nlp-sync-img]').forEach(function (img) {
      if (!s.img) return;
      img.removeAttribute('srcset');
      img.src = s.img;
    });
    document.querySelectorAll('[data-nlp-sync-price]').forEach(function (el) {
      if (s.price) el.textContent = s.price;
    });
    document.querySelectorAll('[data-nlp-sync-compare]').forEach(function (el) {
      el.textContent = s.compare || '';
      el.hidden = !s.compare;
    });
    document.querySelectorAll('[data-nlp-sync-name]').forEach(function (el) {
      el.textContent = s.name || '';
    });
  }

  var LP = (window.NoblLP = {
    state: null,
    set: function (s) {
      this.state = s;
      apply(s);
      document.dispatchEvent(new CustomEvent('nlp:variant', { detail: s }));
    },
    refresh: function () { apply(this.state); }
  });

  /* ---------- Color picker ---------- */
  function stateFrom(picker, btn) {
    return {
      vid: btn.dataset.vid,
      name: btn.dataset.name,
      img: btn.dataset.img,
      price: btn.dataset.price || picker.dataset.price || '',
      compare: btn.dataset.compare || '',
      mode: picker.dataset.mode,
      base: picker.dataset.base,
      custom: picker.dataset.custom
    };
  }

  function initPicker(picker) {
    if (picker.dataset.nlpReady) return;
    picker.dataset.nlpReady = '1';
    picker.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.disabled) return;
      picker.querySelectorAll('button').forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      LP.set(stateFrom(picker, b));
      // Galleries whose first slide follows the color jump back to it (matches the design)
      document.querySelectorAll('.nobl-lp [data-nlp-sync-first] .nlp-slides').forEach(function (s) {
        s.scrollTo({ left: 0 });
      });
    });
    var current = picker.querySelector('button[aria-pressed="true"]') || picker.querySelector('button');
    if (current) {
      current.setAttribute('aria-pressed', 'true');
      var nameEl = picker.parentNode.querySelector('[data-nlp-color-name]');
      if (nameEl) nameEl.textContent = current.dataset.name;
      LP.set(stateFrom(picker, current));
    }
  }

  /* ---------- Countdown ---------- */
  var pad = function (x) { return String(x).padStart(2, '0'); };
  function tick() {
    document.querySelectorAll('[data-nlp-timer]').forEach(function (el) {
      var now = new Date(), end;
      if (el.dataset.end) {
        end = new Date(el.dataset.end);
        if (isNaN(end)) end = null;
      }
      if (!end) { end = new Date(now); end.setHours(24, 0, 0, 0); }
      var s = Math.max(0, ((end - now) / 1000) | 0);
      var h = (s / 3600) | 0;
      var L = el.dataset;
      el.textContent = pad(h) + ' ' + (L.h || 'HRS') + ' : ' + pad(((s % 3600) / 60) | 0) + ' ' + (L.m || 'MIN') + ' : ' + pad(s % 60) + ' ' + (L.s || 'SEC');
      if (s === 0 && el.dataset.hideOnEnd === 'true') el.hidden = true;
    });
  }

  /* ---------- Gallery thumbs ---------- */
  function initGallery(g) {
    if (g.dataset.nlpReady) return;
    g.dataset.nlpReady = '1';
    var slides = g.querySelector('.nlp-slides');
    var thumbs = g.querySelectorAll('.nlp-thumbs button');
    if (!slides || !thumbs.length) return;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
      });
    });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.nobl-lp [data-nlp-picker]').forEach(initPicker);
    document.querySelectorAll('.nobl-lp [data-nlp-gallery]').forEach(initGallery);
    if (document.querySelector('.nobl-lp .nlp-sticky')) {
      document.body.classList.add('nlp-has-sticky');
      var st = document.querySelector('.nobl-lp .nlp-sticky');
      document.body.classList.toggle('nlp-sticky-mobile-only', st.classList.contains('nlp-mobile-only'));
    } else {
      document.body.classList.remove('nlp-has-sticky', 'nlp-sticky-mobile-only');
    }
    LP.refresh();
    tick();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setInterval(tick, 1000);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
})();
